import Image from "next/image"
import styles from "./ProgressSteps.module.scss"
import clsx from "clsx"

const ProgressSteps = ({ step, stepNames }) => {
  return (
    <div className="w-full mb-10 mt-10  font-sans   md:text-lg text-xs">
      <div className="flex mb-2">
        {stepNames.map((name, i) => (
          <div
            key={i}
            className="flex overflow-hidden"
            style={{ width: "auto", cursor: "default" }}
          >
            {i > 0 && (
              <div
                className={clsx(
                  styles["progress-trace"],
                  step < i && styles["__gray"],
                  step >= i && styles["__blue"]
                )}
              />
            )}
            <div
              className="flex text-left"
              style={{
                color: step < i ? "#93A1B1" : "#0019ff",
              }}
            >
              <Image
                width="33"
                height="29"
                src={`/assets/icon-check-${step < i ? "gray" : "blue"}.svg`}
                alt=""
              />

              {name}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProgressSteps
